<template>
  <div class="lc3-shell">
    <Navbar 
      @controlaSidebar="controlaSidebar"
    />
    <div class="container-fluid lc3-shell-body">
      <div class="row h-100">
        <!-- Sidebar para desktop - versão corrigida -->
        <div class="col-lg-2 d-none d-lg-block bg-body-tertiary text-white lc3-sidebar-col border-end">
          <div class="d-flex flex-column flex-shrink-0 pt-3">
            <Sidebar />
          </div>
        </div>

        <div class="offcanvas offcanvas-start" style="max-width: 65%; min-width: 250px;" tabindex="-1" id="sidebaroffcanva" ref="offcanvasElement">
          <div class="text-center p-2 mt-4 border-bottom mb-3">
            <img src="@/assets/logo-cor.png" alt="Logo" width="150px" class="img-fluid mb-3" />
          </div>
          <Sidebar />
        </div>

        <!-- Conteúdo Principal -->
        <main class="col-lg-10 lc3-text-color pt-2 lc3-main">
          <!-- Suporte: administrador da plataforma usando o painel de um cliente -->
          <div v-if="auth.impersonating" class="alert alert-info d-flex flex-wrap align-items-center justify-content-between gap-2 py-2 mb-2 d-print-none">
            <span><i class="bi bi-person-badge me-2"></i>Modo suporte: você está no painel de <strong>{{ auth.tenant?.name }}</strong> como <strong>{{ auth.user?.name }}</strong>.</span>
            <button type="button" class="btn btn-sm btn-dark" @click="auth.stopImpersonation()">Voltar à administração</button>
          </div>
          <!-- Aviso de teste grátis acabando / assinatura vencida -->
          <div v-if="avisoAssinatura" class="alert d-flex flex-wrap align-items-center justify-content-between gap-2 py-2 mb-2 d-print-none" :class="avisoAssinatura.classe">
            <span><i class="bi me-2" :class="avisoAssinatura.icone"></i>{{ avisoAssinatura.texto }}</span>
            <router-link v-if="isAdmin" to="/billing" class="btn btn-sm btn-dark">Ver planos</router-link>
          </div>
          <slot></slot>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Sidebar from '@/components/Sidebar.vue';
import { Offcanvas } from 'bootstrap';
import { computed } from 'vue';
import { useSubscription } from '@/composables/useSubscription';
import { usePermissions } from '@/composables/usePermissions';
import { useAuth } from '@/services/auth';

export default {
  name: "PainelLayout",
  components: { Navbar, Sidebar },
  setup() {
    const { subscription, load } = useSubscription();
    const { isAdmin } = usePermissions();
    const auth = useAuth();
    load();

    const avisoAssinatura = computed(() => {
      const s = subscription.value;
      if (!s) return null;
      if (s.state === 'expired') {
        return { classe: 'alert-danger', icone: 'bi-exclamation-octagon', texto: 'Sua assinatura venceu. O painel está só para consulta e a vitrine saiu do ar.' };
      }
      if (s.state === 'trial' && s.days_left <= 3) {
        return { classe: 'alert-warning', icone: 'bi-hourglass-split', texto: `Seu teste grátis termina em ${s.days_left} dia(s).` };
      }
      if (s.state === 'active' && s.days_left <= 5) {
        return { classe: 'alert-warning', icone: 'bi-calendar-x', texto: `Sua assinatura vence em ${s.days_left} dia(s). Não há renovação automática.` };
      }
      return null;
    });

    return { avisoAssinatura, isAdmin, auth };
  },
  data() {
    return {
      offcanvasInstance: null
    }
  },
  mounted() {
    // Inicializar o offcanvas
    this.initializeOffcanvas();
  },
  methods: {
    initializeOffcanvas() {
      const element = this.$refs.offcanvasElement;
      this.offcanvasInstance = new Offcanvas(element);
      
      // Adicionar event listeners se necessário
      element.addEventListener('hidden.bs.offcanvas', this.onOffcanvasHidden);
      element.addEventListener('shown.bs.offcanvas', this.onOffcanvasShown);
    },
    
    controlaSidebar(acao) {
      if (!this.offcanvasInstance) return;
      
      switch(acao) {
        case "toggle":
          this.offcanvasInstance.toggle();
          break;
        case "open":
          this.offcanvasInstance.show();
          break;
        case "close":
          this.offcanvasInstance.hide();
          break;
      }
    },
    
    onOffcanvasHidden() {
      console.log('Offcanvas fechado');
      // Ações quando fechar
    },
    
    onOffcanvasShown() {
      console.log('Offcanvas aberto');
      // Ações quando abrir
    }
  },
  beforeUnmount() {
    // Limpar quando o componente for destruído
    if (this.offcanvasInstance) {
      this.offcanvasInstance.dispose();
    }
  }
};
</script>

<style scoped>
/* Navbar + área abaixo ocupam exatamente a altura da tela; menu e conteúdo rolam
   cada um por conta própria (com muitos itens no menu, a página não rola junto) */
.lc3-shell {
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.lc3-shell-body {
  flex: 1;
  min-height: 0;
}

.lc3-sidebar-col,
.lc3-main {
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.lc3-navbar-custom {
  background-color: var(--lc3-primary); /* Cor de fundo escura */
}

.lc3-text-color {
  color: var(--lc3-text-color);
}
</style>